export const messages = {
  en: {
    assetInventoryAudit: {
      inventoryInfo: 'Inventory Information',
      inventoryProducts: 'Inventory Products',
      auditOpinion: 'Audit Opinion',
      inventoryName: 'Inventory Name',
      inventoryPerson: 'Inventory Person',
      warehouse: 'Warehouse',
      inventoryDate: 'Inventory Date',
      remark: 'Remark',
      productType: 'Product Type',
      productName: 'Product Name',
      specification: 'Specification',
      productCode: 'Product Code',
      isFixed: 'Is Fixed',
      referencePrice: 'Reference Price',
      originalStock: 'Original Stock',
      afterInventory: 'After Inventory',
      opinionPlaceholder: 'Required, please enter audit opinion',
      opinionRequired: 'Audit opinion cannot be empty',
      approve: 'Approve',
      reject: 'Reject'
    }
  },
  zh: {
    assetInventoryAudit: {
      inventoryInfo: '盘点信息',
      inventoryProducts: '盘点商品',
      auditOpinion: '审核意见',
      inventoryName: '盘点名称',
      inventoryPerson: '盘点人',
      warehouse: '选择仓库',
      inventoryDate: '盘点日期',
      remark: '盘点说明',
      productType: '物品类型',
      productName: '物品名称',
      specification: '物品规格',
      productCode: '物品编码',
      isFixed: '是否是固定物品',
      referencePrice: '参考价格',
      originalStock: '原有库存',
      afterInventory: '盘点后数量',
      opinionPlaceholder: '必填，请输入审核意见',
      opinionRequired: '审核意见不能为空',
      approve: '审核通过',
reject: '审核不通过'
    }
  },
  'zh-TW': {
    assetInventoryAudit: {
      inventoryInfo: '盤點信息',
      inventoryProducts: '盤點商品',
      auditOpinion: '審核意見',
      inventoryName: '盤點名稱',
      inventoryPerson: '盤點人',
      warehouse: '選擇倉庫',
      inventoryDate: '盤點日期',
      remark: '盤點說明',
      productType: '物品類型',
      productName: '物品名稱',
      specification: '物品規格',
      productCode: '物品編碼',
      isFixed: '是否是固定物品',
      referencePrice: '參考價格',
      originalStock: '原有庫存',
      afterInventory: '盤點後數量',
      opinionPlaceholder: '必填，請輸入審核意見',
      opinionRequired: '審核意見不能為空',
      approve: '審核通過',
      reject: '審核不通過'
    }
  }
}